import styled from 'styled-components';

export const SkeltonWrapper = styled.div`
  display: inline-flex;
  width: 100%;
  background: rgba(26, 31, 54, 0.08);
  border-radius: 4px;
`;
